import { useMemo } from "react";

import { GeographicInfoCountry } from "@/Common/Models/Localization/GeographicInfoCountry";
import { GeographicInfoState } from "@/Common/Models/Localization/GeographicInfoState";
import { ContactDirectoryHelper } from "../Helpers/ContactDirectoryHelper";
import { usePreferredPharmacyHelper } from "./usePreferredPharmacyHelper";

export const useDefaultDirectoryCountryAndState = (patientContactId?: string, isForPharmacy?: boolean): { defaultCountry: GeographicInfoCountry, defaultState: GeographicInfoState } => {
    const preferredPharmacyHelper = usePreferredPharmacyHelper(patientContactId);

    return useMemo(
        () => {
            if (!patientContactId || !isForPharmacy)
                return ContactDirectoryHelper.getDefaultCountryAndState();

            const { country, state } = preferredPharmacyHelper.getCountryAndState();

            if (!ContactDirectoryHelper.getSupportedCountries().map(p => p.Id).includes(country?.Id))
                return ContactDirectoryHelper.getDefaultCountryAndState();

            return { defaultCountry: country, defaultState: state };
        },
        [patientContactId, isForPharmacy, preferredPharmacyHelper]
    );
};
